import { classNames } from '../utilities';

export const EmailOpenIcon = ({ className, onClick }) => {
  return (
    <svg
      className={classNames(
        'EmailOpen-icon cursor-pointer',
        className ? className : ''
      )}
      onClick={onClick ? onClick : () => null}
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14.5" cy="14.5" r="14.5" fill="#D9E7FC" />
      <path
        d="M15.2364 7.17204L22.2929 10.9531C22.5668 11.0862 22.7531 11.2614 22.8519 11.4786C22.9506 11.6958 23 11.9158 23 12.1387V20.7253C23 21.0695 22.8581 21.3681 22.5743 21.6208C22.2906 21.8736 21.9554 22 21.569 22H7.42602C7.04091 22 6.70696 21.8736 6.42416 21.6208C6.14139 21.3681 6 21.0695 6 20.7253V12.1387C6 11.9158 6.05119 11.6958 6.15357 11.4786C6.25595 11.2614 6.43879 11.0862 6.70209 10.9531L13.7585 7.17204C13.9911 7.05735 14.2392 7 14.5029 7C14.7665 7 15.011 7.05735 15.2364 7.17204ZM14.4975 15.5988L21.4502 11.9532L14.4975 8.2141L7.54478 11.9532L14.4975 15.5988ZM13.7795 16.5245L7.42602 13.1909V20.7253H21.569V13.1909L15.2155 16.5245C14.9914 16.6392 14.7523 16.6966 14.4984 16.6966C14.2445 16.6966 14.0049 16.6392 13.7795 16.5245Z"
        fill="#002357"
      />
    </svg>
  );
};
